import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.05373 4.69665H15.3033M15.3033 4.69665V12.9462M15.3033 4.69665L4.6967 15.3033",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowUpRight;
